// config.jsonの型定義
export interface AppConfig {
  IOT_MANAGEMENT_ENV: string;
  IOT_MANAGEMENT_API_URL: string;
  IOT_MANAGEMENT_VER: string;
  PASSWORD_VALIDITY_DAYS: number;
}

// config.jsonを読み込む関数
export const getConfig = (): AppConfig => {
  try {
    // config.jsonが存在する場合は読み込み
    const config = require('./config.json') as AppConfig;
    return config;
  } catch (error) {
    console.warn('config.json not found, using default values:', error);
    // デフォルト設定（無期限）
    return {
      IOT_MANAGEMENT_ENV: 'development',
      IOT_MANAGEMENT_API_URL: '',
      IOT_MANAGEMENT_VER: '1.0.0',
      PASSWORD_VALIDITY_DAYS: -1 // デフォルト無期限
    };
  }
};

// パスワード有効期限を取得する関数
export const getPasswordValidityDays = (): number => {
  const config = getConfig();
  return config.PASSWORD_VALIDITY_DAYS;
};
